var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Button.tsx
import React from "react";
var Button = React.forwardRef((props, ref) => {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  return React.createElement(
    "button",
    __spreadValues({
      ref
    }, rest),
    children
  );
});

// src/Link.tsx
import { default as NextLink } from "next/link";
import { jsx } from "react/jsx-runtime";
var Link = (props) => {
  const _a = props, { href, children } = _a, rest = __objRest(_a, ["href", "children"]);
  if (href.startsWith("/")) {
    return /* @__PURE__ */ jsx(NextLink, __spreadProps(__spreadValues({ href }, rest), { children }));
  } else {
    return /* @__PURE__ */ jsx("a", { href, target: "_blank", children });
  }
};

// src/FaIcon/FaIcon.tsx
import { FaIconColor } from "@kcc/api";
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
var FaIcon = ({ type, color = FaIconColor.Primary, size }) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx2("span", { className: "FaIcon" }),
    /* @__PURE__ */ jsx2("style", { jsx: true, children: `
          .FaIcon {
            font-family: "Font Awesome 5 Free-Solid-900";
            color: ${color};
            padding-top: 2px;
            line-height: 30px;
            ${size ? `font-size: ${size}` : null}
          }

          .FaIcon::before {
            content: "${type}";
          }
        ` })
  ] });
};
var FaIcon_default = FaIcon;

// src/SelectInput/SelectInput.tsx
import React2 from "react";
import { Fragment as Fragment2, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var SelectInput = ({
  label,
  name,
  onChange,
  options,
  defaultValue,
  required,
  validationMessage,
  cy
}) => {
  const [value, setValue] = React2.useState("");
  React2.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  return /* @__PURE__ */ jsxs2(Fragment2, { children: [
    /* @__PURE__ */ jsxs2("div", { className: "SelectInput", children: [
      /* @__PURE__ */ jsx3("label", { className: required ? "required" : "", htmlFor: name, children: label }),
      /* @__PURE__ */ jsx3("div", { className: "Select", children: /* @__PURE__ */ jsx3(
        "select",
        {
          "data-cy": cy,
          value,
          onChange: (event) => {
            setValue(event.target.value);
            onChange(event.target.value);
          },
          children: options.map((option) => /* @__PURE__ */ jsx3("option", { value: option.value, children: option.label }, option.value))
        }
      ) }),
      validationMessage ? /* @__PURE__ */ jsx3("div", { "data-cy": `${cy}-validation`, className: "validation", children: validationMessage }) : null
    ] }),
    /* @__PURE__ */ jsx3("style", { jsx: true, children: `
          .SelectInput {
          }

          label {
            display: block;
            margin: 0 0 4px 0;
            color: #a8b6be;
            font-size: 0.8rem;
          }

          .required:after {
            content: ${required ? "'*'" : ""};
            color: red;
          }

          select {
            width: 100%;
            border: 0;
            padding: 7px 10px;
            color: ${value == null || !value.length ? "#a8b6be" : "black"};
          }

          .Select {
            border: 1px solid #a8b6be;
          }

          .validation {
            margin-top: 4px;
            color: red;
            font-size: 0.8rem;
          }
        ` })
  ] });
};
var SelectInput_default = SelectInput;

// src/TextInput/TextInput.tsx
import React3 from "react";
import { Fragment as Fragment3, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var TextInput = ({
  label,
  name,
  onChange,
  defaultValue,
  required,
  validationMessage,
  cy
}) => {
  const [value, setValue] = React3.useState("");
  React3.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  return /* @__PURE__ */ jsxs3(Fragment3, { children: [
    /* @__PURE__ */ jsxs3("div", { className: "TextInput", children: [
      /* @__PURE__ */ jsx4("label", { className: required ? "required" : "", htmlFor: name, children: label }),
      /* @__PURE__ */ jsx4(
        "input",
        {
          type: "text",
          name,
          value,
          onChange: (event) => {
            setValue(event.target.value);
            onChange(event.target.value);
          },
          placeholder: label,
          "data-cy": cy
        }
      ),
      validationMessage ? /* @__PURE__ */ jsx4("div", { "data-cy": `${cy}-validation`, className: "validation", children: validationMessage }) : null
    ] }),
    /* @__PURE__ */ jsx4("style", { jsx: true, children: `
          .TextInput {
          }

          label {
            display: block;
            margin: 0 0 4px 0;
            color: #a8b6be;
            font-size: 0.8rem;
          }

          .required:after {
            content: ${required ? "'*'" : ""};
            color: red;
          }

          input {
            border: 1px solid #a8b6be;
            display: block;
            width: 100%;
            padding: 8px 16px;
          }

          input::placeholder {
            color: #a8b6be;
          }

          .validation {
            margin-top: 4px;
            color: red;
            font-size: 0.8rem;
          }
        ` })
  ] });
};
var TextInput_default = TextInput;

// src/Tooltip/Tooltip.tsx
import { useState } from "react";
import { Fragment as Fragment4, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var Tooltip = ({ html, themeColor, tooltipWidth }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return /* @__PURE__ */ jsx5(Fragment4, { children: /* @__PURE__ */ jsxs4("div", { className: "tooltip-container", children: [
    /* @__PURE__ */ jsx5(
      "div",
      {
        className: "tooltip-icon",
        onMouseOver: () => setShowTooltip(true),
        onMouseOut: () => setShowTooltip(false),
        children: /* @__PURE__ */ jsx5(FaIcon_default, { type: "\\f05a" })
      }
    ),
    showTooltip && /* @__PURE__ */ jsx5("div", { className: "tooltip", dangerouslySetInnerHTML: { __html: html } }),
    /* @__PURE__ */ jsx5("style", { jsx: true, children: `
          .tooltip-container {
            position: relative;
          }

          .tooltip-icon {
            margin: 0 5px;
          }

          .tooltip {
            width: ${tooltipWidth != null ? tooltipWidth : "400px"};
            font-size: 12px;
            position: absolute;
            right: 0;
            z-index: 99999;
            background-color: rgba(255, 255, 255, 1);
            padding: 15px 25px;
            border: solid 2px ${themeColor};
          }
        ` })
  ] }) });
};
var Tooltip_default = Tooltip;

// src/GiftItemTooltipHtml.ts
var GiftItemTooltipHtml = "<span>If you would like to purchase a course for another person or multiple people, select <strong>Gift Item</strong> when checking out. After your purchase is complete, you will be able to go the <strong>My Gifts</strong> page and share purchased course licenses with other users by providing their email addresses.</span>";
var GiftItemTooltipHtml_default = GiftItemTooltipHtml;
export {
  Button,
  FaIcon_default as FaIcon,
  GiftItemTooltipHtml_default as GiftItemTooltipHtml,
  Link,
  SelectInput_default as SelectInput,
  TextInput_default as TextInput,
  Tooltip_default as Tooltip
};
